module.exports = __webpack_public_path__ + "img/xcm_logo.2b84135a.png";